import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

const SmartLink = ({ to, children, className, fadeDuration = 850, ...props }) => {
    const history = useHistory();
    const location = useLocation();

    const toPath = typeof to === 'string' ? to : (to && to.pathname);
    const normalizePath = (path) => (path ? path.replace(/\/+$/, '') || '/' : path);
    const isActive = toPath && normalizePath(location.pathname) === normalizePath(toPath);
    const linkClassName = `${className || ''}${isActive ? ' state-active' : ''}`.trim();

    const handleClick = (e) => {
        e.preventDefault();

        // Remove page state classes to trigger fade-out
        const classesToRemove = [
            'state-page-loaded', 'state-menu-open', 'state-page-load-complete',
            'state-splash-header', 'state-front-page', 'state-scrolled',
            'state-show-splash', 'state-show-block'
        ];
        classesToRemove.forEach(cls => document.documentElement.classList.remove(cls));

        // Optional: lock scroll during transition
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';

        console.log('Navigating to', to);

        // Wait for fade duration before navigating
        setTimeout(() => {
            history.push(to);
            console.log('Navigated to', to);
            // Unlock scroll after navigation
            document.documentElement.style.overflow = '';
            document.body.style.overflow = '';
        }, fadeDuration);
    };

    return (
        <a href={to} onClick={handleClick} className={linkClassName} {...props}>
            {children}
        </a>
    );
};

export default SmartLink;
